export const LABELS_BY_OFFER_TYPE_ID = {
  [-1]: 'COMMON.ALL',
  0: 'COMMON_OPPORTUNITY',
  1: 'COMMON.OFFER_TYPE.NEW',
  2: 'COMMON.OFFER_TYPE.KM0',
  3: 'COMMON.OFFER_TYPE.SUBSTITUTION',
  4: 'COMMON.OFFER_TYPE.MANAGEMENT',
  5: 'COMMON.OFFER_TYPE.DEMONSTRATION'
}
